import { API_PREFIX, paginatedFromDto, type HttpClient } from "@nasam/kernel";
import type { BranchesRepository } from "../domain";
import { branchFromDto } from "./organizationMappers";
import { branchListResponseDtoSchema } from "./organizationDtos";

export function createBranchesHttpRepository(
  http: HttpClient,
): BranchesRepository {
  return {
    async list(query) {
      const response = await http.get(`${API_PREFIX}/branches`, {
        params: query,
      });
      return paginatedFromDto(
        branchListResponseDtoSchema.parse(response),
        branchFromDto,
      );
    },
  };
}
